/*
 * Copyright © 2024. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { getLitigationCaseBadges } from "./getLitigationCaseBadges";
import { DataLeakContract } from "../../../types/Products/ContractLaw/DataLeakContract";

export const getDataLeakContractBadges = (product: DataLeakContract) => {
  let badges = getLitigationCaseBadges(product);

  if (product.primaryCreditAgency) {
    badges.push({
      text: product.primaryCreditAgency.toUpperCase(),
      isActive: true,
    });
  }

  return badges;
};
